import { useState, useEffect } from 'react';

const FIRST_VISIT_KEY = 'has_visited_before';

const useFirstVisit = () => {
  const [isFirstVisit, setIsFirstVisit] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const hasVisited = localStorage.getItem(FIRST_VISIT_KEY);

    if (!hasVisited) {
      setIsFirstVisit(true);
      localStorage.setItem(FIRST_VISIT_KEY, 'true');
    }

    setChecked(true);
  }, []);

  return { isFirstVisit, checked };
}

export default useFirstVisit